export default __webpack_public_path__ + "static/media/microscopio.23b6b357.png";